// helper to capitalize strings
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/~/inline-style-prefix-all/lib/utils/capitalizeString.js
 ** module id = 565
 ** module chunks = 0 2
 **/